(function ($, Cobalt, undefined) {
    'use strict';

    Cobalt.StickyElement = {
        parentHeight: 0,
        parentTop: 0,
        parentBottom: 0,
        scrollTop: 0,
        elHeight: 0,
        el: null,
        parent: null,

        initialize: function(element) {
            Cobalt.StickyElement.el = element;
            Cobalt.StickyElement.parent = Cobalt.StickyElement.el.parent();

            Cobalt.Throttle.initialize();
            Cobalt.StickyElement.makeSticky();
        },

        calcSizingInfo: function() {
            var parentElTop = Cobalt.StickyElement.parent.offset().top;
            Cobalt.StickyElement.parentHeight = Cobalt.StickyElement.parent.height();
            Cobalt.StickyElement.parentBottom = Cobalt.StickyElement.parentHeight + parentElTop;
            Cobalt.StickyElement.parentTop = parentElTop;
            Cobalt.StickyElement.elHeight = Cobalt.StickyElement.el.height();
        },

        fixHeaderIfNeeded: function() {
            Cobalt.StickyElement.el.removeClass('se-fixed');

            if (Cobalt.StickyElement.elHeight >= Cobalt.StickyElement.parentHeight) {
                return;
            } else if (Cobalt.StickyElement.scrollTop + 20 + Cobalt.StickyElement.elHeight >= Cobalt.StickyElement.parentBottom) {
                Cobalt.StickyElement.el.addClass('se-fixed').css({
                    top: '30px',
                    position: 'fixed'
                });
            } else if (Cobalt.StickyElement.scrollTop + 20 >= Cobalt.StickyElement.parentTop ) {
                Cobalt.StickyElement.el.addClass('se-fixed').css({
                    top: '20px',
                    position: 'fixed'
                });
            } else {
                // top
                Cobalt.StickyElement.el.css({
                    top: 'auto',
                    position: 'unset'
                });
            }
        },

        handleResize: function() {
            Cobalt.StickyElement.calcSizingInfo();
            Cobalt.StickyElement.fixHeaderIfNeeded();
        },

        handleScroll: function() {
            Cobalt.StickyElement.scrollTop = $(window).scrollTop();
            Cobalt.StickyElement.fixHeaderIfNeeded();
        },

        makeSticky: function(el) {
            Cobalt.StickyElement.calcSizingInfo();
            $(window).on('scroll', throttle(Cobalt.StickyElement.handleScroll, 100));
            $(window).on('resize', throttle(Cobalt.StickyElement.handleResize, 200));
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.StickyElement.js